export default __webpack_public_path__ + "bd5b28a0e58181fd865713e61ff03d44.svg";